<template>
  <v-dialog
      v-model="showForm"
      max-width="400px"
      transition="dialog-top-transition"
      persistent
  >
    <v-card>
      <v-toolbar dark color="primary">
        <v-toolbar-title>
          <h4 class="title">{{title}}</h4>
        </v-toolbar-title>
        <v-spacer></v-spacer>
        <v-btn
            icon
            dark
            @click="closed"
        >
          <v-icon>mdi-close</v-icon>
        </v-btn>
      </v-toolbar>
      <v-form>
        <v-card-text>
          <div class="md-layout">
            <div >
              <v-text-field
                  v-model="municipio.nombre"
                  label="Municipio"
              />
              <v-text-field
                  v-model="municipio.code"
                  label="Código"
              />
              <v-select
                  v-model="estado"
                  :items="estados"
                  item-text="nombre"
                  item-value="id"
                  label="Selecciona el Estado"
                  chips
                  hint="Estado"
                  persistent-hint
              ></v-select>
            </div>
          </div>
        </v-card-text>
        <v-card-actions>
          <v-spacer></v-spacer>
          <v-btn color="terciary" @click="closed">
            Cancelar
          </v-btn>
          <v-btn v-if="title==='Actualizar Municipio'" color="secondary" @click="update" :loading="loading">
            Actualizar
          </v-btn>
          <v-btn v-else color="secondary" @click="create" :loading="loading">
            Crear
          </v-btn>
        </v-card-actions>
      </v-form>
    </v-card>
  </v-dialog>
</template>

<script>
import { mapGetters } from 'vuex';

export default {
  name: "MunicipioForm",
  props: {
    title: String,
    municipio: {},
    showForm: {
      type: Boolean,
      default: false,
    },
  },
  computed: {
    ...mapGetters(['estados']),
  },
  data: ()=>({
    loading: false,
    estado:{},
  }),
  mounted() {
    this.estado = this.municipio.estado ? this.municipio.estado.id : null ;
  },
  methods: {
    async create() {
      this.loading= true;
      this.municipio.estado = this.estado;
      await this.$store.dispatch('createMunicipio', this.municipio);
      this.loading= false;
      this.closed();
    },
    async update() {
      this.loading= true;
      this.municipio.estado = this.estado;
      await this.$store.dispatch('updateMunicipio', this.municipio);
      this.loading= false;
      this.closed();
    },
    closed() {
      this.$emit('close');
    },
  },
}
</script>

<style scoped>

</style>
